import { HttpHandler, RpcClient } from 'casper-js-sdk';

/**
 * CORS-friendly Casper node proxy (MAKE API gateway).
 * Direct node.testnet.casper.network calls are blocked by CORS in browsers —
 * all browser-side RPC must go through this proxy.
 */
export const CASPER_RPC_PROXY_URL = 'https://cspr-api-gateway.dev.make.services/cspr-node-proxy-dev/rpc';
export const CASPER_RPC_PROXY_HEADERS: Record<string, string> = {
  Authorization: '019324f2-8f7e-7387-bcc2-88b7f5713798',
};

const rpcHandler = new HttpHandler(CASPER_RPC_PROXY_URL);
rpcHandler.setCustomHeaders(CASPER_RPC_PROXY_HEADERS);

// Single shared RPC client instance
export const sharedRpcClient = new RpcClient(rpcHandler);
